import React from "react";
import { Copy } from "react-feather";
import styled from "styled-components";
import { Toast } from "utility/helpers";
import { Card, Row, Col } from "reactstrap";

const OthersNameText = styled.h3`
  margin-bottom: 10px;
`;

const CongDetailsContainer = styled(Card)`
  padding: 20px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 25px;
  border: none;
  align-items: center;
  box-shadow: 4px 9px 17px -1px #00000014;
  margin-top: 44px;
`;

const CongDetailsRow = styled(Row)`
  width: 100%;
  margin-top: 10px;
`;

const CongDetailsLeft = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FormLabel = styled.span`
  font-weight: 500;
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin-bottom: 8px;
`;

const FormValue = styled.span`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.textBlue};
  text-align: end;
`;

const OthersDetailsCard = ({ congDetails }) => {
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);

      Toast({
        type: 1,
        content: "Phone number copied to clipboard!",
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);

      Toast({
        type: 4,
        content: "Something went wrong.",
      });
    }
  };

  return (
    <CongDetailsContainer>
      <CongDetailsRow>
        <CongDetailsLeft>
          <OthersNameText>
            {congDetails?.fullName || congDetails?.name}
          </OthersNameText>
          <Col
            xs="12"
            md="4"
          >
            <FormRow>
              <FormLabel>{"Position"}</FormLabel>
              <FormValue>
                {congDetails?.committeeChairmanship ||
                  congDetails?.position ||
                  "-"}
              </FormValue>
            </FormRow>
          </Col>
          <Col
            xs="12"
            md="4"
          >
            <FormRow>
              <FormLabel>{"Contact Number"}</FormLabel>
              <div className="d-flex align-items-center justify-content-end">
                {congDetails?.contact ? (
                  <div className="d-flex align-items-center">
                    <a
                      href={`tel:+63${congDetails.contact.substring(1)}`}
                      style={{
                        textDecoration: "none",
                        cursor: "pointer",
                        color: "#00326E",
                      }}
                      title="Click to call"
                    >
                      {congDetails.contact}
                    </a>
                    <button
                      type="button"
                      className="btn btn-link p-0"
                      onClick={() => copyToClipboard(congDetails.contact)}
                      title="Copy to clipboard"
                      style={{
                        border: "none",
                        background: "none",
                        marginLeft: "0.5rem",
                        padding: 0,
                      }}
                    >
                      <Copy size={14} />
                    </button>
                  </div>
                ) : (
                  <FormValue>{"-"}</FormValue>
                )}
              </div>
            </FormRow>
          </Col>
        </CongDetailsLeft>
      </CongDetailsRow>
    </CongDetailsContainer>
  );
};

export default OthersDetailsCard;
